import { createFileRoute } from "@tanstack/react-router"
import { ConfirmApprovalPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/confirm"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ORGANIZATION} action={Action.MANAGE}>
      <ConfirmApprovalPage />
    </AuthorizationGate>
  ),
})
